import React from "react";
import _ from "underscore";
import { hasPermission } from "../../../api/session";
import { isNotEmpty, isEmpty } from "../../../framework/utils";
import { optional, parseBoolean, uuid } from "../../../utils/lang";
import { MaterialIcon, MaterialIconWithTooltip } from "../materialIcon";
import withDropdown from "./dropdown";

export const ACTION_TYPES = {
    ICON: "icon",
    DROPDOWN: "dropdown",
    BUTTON: "button",
    CUSTOM: "custom",
}

export default class Actions extends React.Component {
    constructor(props) {
        super(props);
        this.uuid = uuid();
    }

    mapActions() {
        const actions = _.filter(optional(this.props.actions, []), a => hasPermission(a.permissions) === true);
        return _.map(actions, (a, index) => {
            const key = "actions-" + this.uuid + "_action-" + a.id;
            
            return (<Action
                        key={key}
                        {...a}
                    />);
        })
    }

    render() {
        const className = "actions actions--mobile" + (isNotEmpty(this.props.className) ? " " + this.props.className : ""),
            actions = this.mapActions();
        return(
            <div
                className={className}
            >
                {actions}
            </div>
        )
    }
}

class Action extends React.Component {
    getComponent() {
        const {type, component} = this.props;
        switch (type) {
            case ACTION_TYPES.ICON:
                return IconAction;
            case ACTION_TYPES.DROPDOWN:
                return DropdownAction;
            case ACTION_TYPES.BUTTON:
                return ButtonAction;
            case ACTION_TYPES.CUSTOM:
                return component;
            default:
                return undefined;
        }
    }

    sanitizeProps() {
        const {type, className} = this.props;
        switch(type) {
            case ACTION_TYPES.CUSTOM:
                return _.extend(
                        {},
                        this.props,
                        {
                            className: isEmpty(className) ? "actions__item" : className + " actions__item"
                        }
                    )
            default:
                return {...this.props};
        }
    }

    render() {
        const Component = this.getComponent(),
            _props = this.sanitizeProps();

        return (
            <Component
                {..._props}
            />
        )
    }
}

class IconAction extends React.Component {

    getComponent() {
        const title = this.props.title;

        return isNotEmpty(title) ? MaterialIconWithTooltip : MaterialIcon;
    }

    render() {
        const Component = this.getComponent(),
            className = "actions__item" + (isNotEmpty(this.props.className) ? " " + this.props.className : "");
        return(
            <Component
                {...this.props}
                className={className}
            />
        )
    }
}

class DropdownAction extends React.Component {
    constructor(props) {
        super(props);
        this.uuid = uuid();
    }

    onItemClick(item) {
        if (item.onClick && _.isFunction(item.onClick)) {
            item.onClick();
        }
    }

    getItems() {
        const items = _.filter(optional(this.props.items, []), item => hasPermission(item.permissions) === true);
        return _.map(items, item => {
            const icon = item.icon,
                title = item.title;

            return(
                <div
                    onClick={() => this.onItemClick(item)}
                    className="actions__dropdown-item"
                >
                    <MaterialIcon
                        icon={icon}
                    />
                    {title}
                </div>
            )
        })
    }

    render() {
        const items = this.getItems(),
            className = "actions__item actions__item--dropdown" + (isNotEmpty(this.props.className) ? " " + this.props.className : ""),
            Component = withDropdown(IconAction, items);
        
        return (
            <div
                className={className}
            >
                <Component
                    {..._.omit(this.props,"items", "icon", "className")}
                    icon={this.props.icon || "more_vert"}
                    className="actions__dropdown-trigger"
                />
            </div>
        )
    }
}

class ButtonAction extends React.Component {
    
    onClick() {
        if (this.props.onClick && _.isFunction(this.props.onClick)) {
            this.props.onClick();
        }
    }

    render() {
        const text = this.props.text,
            disabled = parseBoolean(optional(this.props.disabled, false)),
            className = "actions__item actions__item--btn btn" + (isNotEmpty(this.props.className) ? " " + this.props.className : " btn-primary");
        return (
            <button
                disabled={disabled}
                type="button"
                className={className}
                onClick={this.onClick.bind(this)}
            >
                {text}
            </button>
        )
    }
}